import { styled } from "styled-components";

export const CustomerReviewsSectionHeadline = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  color: ${({ theme }) => theme.colors.default[900]};
  text-align: center;
  font-size: 32px;
  font-style: normal;
  font-weight: 600;
  line-height: 100%; /* 32px */
  letter-spacing: 0.96px;
`;

export const ReviewsSections = styled.div`
  display: flex;
  gap: 12px;
  align-items: center;

  ${({ theme }) => theme.breakpoints.lg.query} {
    flex-direction: column;
  }
`;

export const ReviewersSection = styled.div`
  display: flex;
  gap: 12px;
  align-items: center;
  color: ${({ theme }) => theme.colors.default[400]};
  font-size: 14px;
  font-style: normal;
  font-weight: 550;
  line-height: 150%; /* 21px */
`;

export const ReviewersIcons = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  height: 21px;
  width: 86px;
`;
